/**
 * certificates — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const certificatesPack: ToilePack = {
    slug: 'certificates',
    category: 'certificates',
    name: 'Certificates',
    tagline: tagline('certificates', 'kinds', 'styles'),
    chips: chips('kinds', 'styles'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'excellence', label: 'Award of excellence', subject: 'a laurel wreath, a rosette ribbon, a guilloche border'},
        {key: 'kids', label: 'Kids reward', subject: 'stars, a smiling sun, a rainbow and a cartoon trophy'},
        {key: 'gift', label: 'Gift certificate', subject: 'a ribbon-tied parcel, thin rules and a blank value box'},
    ],
    styles: [
        {key: 'engraved', label: 'Classic engraved', style: 'dense intaglio linework, a scrolled double frame', palette: 'deep navy and gold on ivory', framing: 'landscape, heading above blank name lines'},
        {key: 'playful', label: 'Playful', style: 'thick rounded shapes, a bouncy hand-drawn border', palette: 'bright primaries, cheerful', framing: 'landscape, heading above blank name lines'},
        {key: 'minimal', label: 'Modern minimal', style: 'one hairline rule, a single small accent shape', palette: 'restrained neutrals, wide white space', framing: 'landscape, heading above blank name lines'},
    ],
    directions: ['for a sports club', 'in green and gold', 'with a seal and ribbon'],
}
